//////////////////////////////////////////////////////////////////////
//
//  10/05/18
//  src/components/FullBlk.js
//
//  This file is a single block of full data.
//

import React   from 'react';
import NameBlk from "./NameBlk";
import BBoard  from "./BBoard";
import './FullBlk.css';

const FullBlk = ({ miles, name, row, music, food, happy, notes, board, line1, line2, line3, line4, mpop, fpop, hpop, addr }) => (
  <div className="FullBlk">

    <div className="FullBlkName">
      <NameBlk row={ row }     name={ name } miles={ miles } type={ "full" }
               music={ music } food={ food } happy={ happy } notes={ notes }
               mpop ={ mpop  } fpop={ fpop } hpop ={ hpop  } addr ={ addr  } />
    </div>

    <div className="FullBlkBoard">
      { board && ( <BBoard line1={ line1 } line2={ line2 } line3={ line3 } line4={ line4 } /> )}
    </div>

  </div>
);

export default FullBlk;



// WEBPACK FOOTER //
// ./src/components/FullBlk.js